<template>
  <div ref="panel" class="coupon-panel" @click.stop>
    <div class="header">
      <span class="title">优惠券</span>
      <i class="el-icon-close" @click="hidePanel"></i>
    </div>
    <div class="main">
      <div class="coupon-header">
        <div class="line"></div>
        <div class="text">可领取的券</div>
        <div class="line"></div>
      </div>
      <div class="list">
        <div
          class="item"
          :class="{ disabled: item.is_can_get != 1 }"
          v-for="item in list"
          :key="item.id"
        >
          <div class="left">
            <div class="discount-scope">
              <CurrencyNew :price="item.discounted_price"></CurrencyNew>
              <div class="scope">{{ getScope(item) }}可用</div>
            </div>
            <div class="full_reduction">满{{ item.full_reduction / 100 }}可用</div>
            <div class="time">{{ getTime(item) }}</div>
          </div>
          <div class="right" @click="onClick(item)">
            {{ item.is_can_get == 1 ? '立即领取' : '无法领取' }}
          </div>
        </div>
      </div>
      <div class="coupon-header coupon-header-get">
        <div class="line"></div>
        <div class="text">已领取的券</div>
        <div class="line"></div>
      </div>
      <div class="list">
        <div class="item item-get" v-for="item in couponGetList" :key="item.id">
          <div class="left">
            <div class="discount-scope">
              <CurrencyNew :price="item.discounted_price"></CurrencyNew>
              <div class="scope">{{ getScope(item) }}可用</div>
            </div>
            <div class="full_reduction">满{{ item.full_reduction / 100 }}可用</div>
            <div class="time">
              有效期{{
                ' ' + item.valid_start.replace(/-/g, '/') + '-' + item.valid_end.replace(/-/g, '/')
              }}
            </div>
          </div>
          <div class="right" @click="onUseClick(item)">立即使用</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CouponPanel',
  props: {
    couponList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      list: [],
      couponGetList: [],
      isMounted: false,
    };
  },
  async created() {
    this.list = [...this.couponList];
    await this.getCouponList();
  },
  mounted() {
    this.$nextTick(() => {
      document.body.appendChild(this.$el);
      document.addEventListener('click', this.hidePanel);
      setTimeout(() => {
        this.$refs.panel.classList.add('coupon-panel-mount');
      });
    });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hidePanel);
  },
  methods: {
    hidePanel() {
      this.$emit('hidePanel');
    },
    async getCouponList() {
      this.couponGetList = await this.$http.get('/api/app/coupon', {
        status: 0,
      });
    },
    getScope(item) {
      if (item.dis_type == 1) {
        return item.scope_type == 1
          ? '全部课程'
          : item.scope_type == 2
          ? '指定课程分类'
          : '指定课程';
      } else if (item.dis_type == 4) {
        return item.scope_type == 1 ? '全部约课' : item.scope_type == 2 ? '指定讲师' : '';
      } else if (item.dis_type == 2) {
        return item.scope_type == 1
          ? '全部实物商品'
          : item.scope_type == 2
          ? '指定实物商品分类'
          : '指定实物商品';
      } else if (item.dis_type == 6) {
        return item.scope_type == 1
          ? '全部电子书'
          : item.scope_type == 2
          ? '指定电子书分类'
          : '指定电子书';
      }
    },
    getTime(item) {
      let time = '有效期 ';
      if (item.valid_type == 1) {
        time += item.valid_day + '天';
      } else {
        time +=
          new Date(item.valid_start * 1000).format('yyyy/MM/dd') +
          '-' +
          new Date(item.valid_end * 1000).format('yyyy/MM/dd');
      }
      return time;
    },
    async onClick(item) {
      if (item.is_can_get != 1) {
        return;
      }
      let data = await this.$http.get('/api/app/userGetCoupon/' + item.id);
      this.list.filter((c) => c.id == item.id)[0].is_can_get = data.is_continue_get == 1 ? 1 : 0;
      this.$message({
        message: '领取成功',
        type: 'success',
      });
      await this.getCouponList();
    },
    onUseClick(item) {
      this.hidePanel();
      this.$nextTick(() => {
        this.$services.CouponService.goToUsePage(item);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.coupon-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(230, 230, 230, 1);
  border: 1px solid rgba(217, 217, 217, 1);
  box-shadow: -4px 1px 8px 0px rgba(204, 204, 204, 0.6);
  z-index: 9999;
  box-sizing: border-box;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  width: 0;
  transition: width 0.5s;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 23px 0 28px 0;
    padding-right: 20px;

    .title {
      font-size: 18px;
      color: #343434;
    }

    .el-icon-close {
      font-size: 16px;
      color: #9a9a9a;
      cursor: pointer;
    }
  }

  .main {
    flex-grow: 1;
    overflow-y: auto;
  }

  .coupon-header {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #343434;
    margin-bottom: 20px;

    .line {
      height: 1px;
      background: rgba(0, 0, 0, 1);
      opacity: 0.07;
      flex-grow: 1;
    }

    .text {
      margin: 0 6px;
    }
  }

  .item {
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    display: flex;
    margin-bottom: 20px;
    color: #ff2e28;
    width: 250px;

    &.disabled {
      cursor: not-allowed;
      color: #9a9a9a;

      .left {
        border-right-color: #a6a6a6;
      }

      .right {
        background: #a6a6a6;
      }

      ::v-deep {
        .price {
          color: #9a9a9a;
        }
      }
    }

    .left {
      flex-grow: 1;
      border-right: 3px dotted #ff2e28;
      padding: 20px 0 0 11px;
    }

    .right {
      width: 38px;
      box-sizing: border-box;
      background: #ff2e28;
      border-radius: 0 5px 5px 0;
      color: white;
      writing-mode: vertical-lr;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .discount-scope {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
    }

    .scope {
      font-size: 14px;
      margin-left: 8px;
    }

    ::v-deep {
      .price-wrap {
        justify-content: flex-start;
      }
      .price {
        font-size: 24px;
      }
    }

    .full_reduction {
      font-size: 12px;
      margin-bottom: 6px;
    }

    .time {
      font-size: 12px;
      margin-bottom: 13px;
    }
  }

  .coupon-header-get {
    margin-top: 10px;
  }

  .item-get {
    background: url('~@/assets/images/coupon/has-get@2x.png') no-repeat 132px top;
    background-size: 79px 57px;
    background-color: white;
  }
}
.coupon-panel-mount {
  width: 290px;
}
</style>
